(function () {

    'use strict';

    angular.module('iplusjs.validator', [])
        .directive('iplusjsValidator', validator);

    validator.$inject = [
        'lodash'
    ];
    function validator(_) {
        return {
            restrict: 'A',
            require: ['^form', '?ngModel'],
            link: function ($scope, $elem, $attrs, ctrls) {
                var validatorName = $attrs.iplusjsValidator,
                    validation = $scope.$eval($attrs.ivValidation),
                    validationItems = $scope.$eval($attrs.ivValidationItems) || [],
                    formCtrl = ctrls[0],
                    ctrl = ctrls[1] || formCtrl,
                    ngModelCtrl = ctrls[1];

                if (!validatorName || !validation || !angular.isFunction(validation)) {
                    return;
                }

                if (ngModelCtrl && !validationItems.length) {
                    ngModelCtrl.$validators[validatorName] = validation;
                } else {
                    $scope.$watch(function () {
                        return validation.call();
                    }, function (valid) {
                        if (validationItems && validationItems.length) {
                            _.forEach(validationItems, function (validationItem) {
                                _.forEach(_.filter(formCtrl.$getControls(), ['$name', validationItem]), function (item) {
                                    if (item && angular.isFunction(item.$setValidity)) {
                                        if (!valid && item.$dirty) {
                                            item.$setTouched();
                                        }
                                        item.$setValidity(validatorName, valid);
                                    }
                                });
                            });
                        } else {
                            ctrl.$setValidity(validatorName, valid);
                        }
                    });
                }
            }
        };
    }
})();
